import { QUESTIONS } from "@/data/questions";

const byId = Object.fromEntries(QUESTIONS.map((q) => [q.id, q]));
const LEGACY_CONCERNS = ["probate", "protecting_home", "wills_trusts", "leaving_money", "organizing_documents", "healthcare_decisions", "not_sure"];

export const LEGACY_QUESTIONS = [
  byId.q1,
  byId.q2,
  { ...byId.q5, title: "When did you last review the beneficiaries on your accounts and policies?" },
  byId.q6,
  byId.q7,
  byId.q8,
  byId.q9,
  { ...byId.q10, options: byId.q10.options.filter((o) => LEGACY_CONCERNS.includes(o.value)) },
];

export const FAMILY_QUESTIONS = [
  {
    id: "f1",
    title: "Who depends on you financially?",
    type: "single",
    options: [
      { value: "spouse", label: "Spouse or partner" },
      { value: "children", label: "Children" },
      { value: "parents", label: "Parents or other family members" },
      { value: "business", label: "Business partner or employees" },
      { value: "none", label: "No one currently" },
    ],
  },
  {
    id: "f2",
    title: "Do you currently have life insurance?",
    type: "single",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
      { value: "unsure", label: "Not sure" },
    ],
  },
  {
    id: "f3",
    title: "When was your life insurance coverage last reviewed?",
    type: "single",
    options: [
      { value: "within_year", label: "Within the last year" },
      { value: "1_3_years", label: "1–3 years ago" },
      { value: "over_3_years", label: "More than 3 years ago" },
      { value: "never", label: "I've never reviewed it" },
      { value: "no_coverage", label: "I don't currently have coverage" },
      { value: "unsure", label: "Not sure" },
    ],
  },
  {
    id: "f4",
    title: "Do you know whether your current life insurance includes living benefits?",
    type: "single",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
      { value: "unsure", label: "Not sure" },
      { value: "no_coverage", label: "I don't currently have coverage" },
    ],
  },
  {
    id: "f5",
    title: "If something happened to you today, how would your family handle final expenses and immediate financial obligations?",
    type: "single",
    options: [
      { value: "insurance", label: "Existing life insurance" },
      { value: "savings", label: "Savings or investments" },
      { value: "family", label: "Family would handle the expenses" },
      { value: "combination", label: "A combination of resources" },
      { value: "unsure", label: "I'm not sure" },
    ],
  },
  {
    id: "f6",
    title: "What would you most want your protection plan to accomplish?",
    subtitle: "Select all that apply.",
    type: "multi",
    options: [
      { value: "income", label: "Replace income for my family" },
      { value: "mortgage", label: "Help protect or pay off the mortgage/home" },
      { value: "final_expenses", label: "Cover final expenses" },
      { value: "children", label: "Leave money to children or grandchildren" },
      { value: "illness", label: "Provide financial protection if I experience a qualifying serious illness" },
      { value: "business", label: "Protect my business" },
      { value: "legacy", label: "Build or leave a financial legacy" },
      { value: "unsure", label: "I'm not sure yet", exclusive: true },
    ],
  },
  {
    id: "f7",
    title: "What would you most like help understanding?",
    type: "single",
    options: [
      { value: "how_much", label: "How much life insurance coverage I may need" },
      { value: "existing_fit", label: "Whether my existing coverage still fits my needs" },
      { value: "term_vs_perm", label: "Term vs. permanent life insurance" },
      { value: "living_benefits", label: "Living benefits" },
      { value: "final_expense", label: "Final expense planning" },
      { value: "family_legacy", label: "Family and legacy protection" },
      { value: "exploring", label: "I'm just exploring" },
    ],
  },
];

export const MEDICARE_QUESTIONS = [
  {
    id: "m1",
    title: "Are you currently enrolled in Medicare?",
    type: "single",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
      { value: "soon", label: "Becoming eligible soon" },
      { value: "unsure", label: "Not sure" },
    ],
  },
  {
    id: "m2",
    title: "What coverage do you currently have?",
    type: "single",
    options: [
      { value: "original", label: "Original Medicare" },
      { value: "advantage", label: "Medicare Advantage" },
      { value: "supplement", label: "Medicare Supplement + Part D" },
      { value: "employer", label: "Employer or retiree coverage" },
      { value: "unsure", label: "Not sure" },
    ],
  },
  {
    id: "m3",
    title: "What would you like help understanding?",
    subtitle: "Select all that apply.",
    type: "multi",
    options: [
      { value: "costs", label: "Costs" },
      { value: "doctors", label: "Doctors and providers" },
      { value: "prescriptions", label: "Prescriptions" },
      { value: "dental_vision_hearing", label: "Dental, vision and hearing" },
      { value: "extra_benefits", label: "Extra benefits" },
      { value: "review_coverage", label: "Reviewing current coverage" },
      { value: "eligibility", label: "Becoming eligible" },
      { value: "other", label: "Something else" },
    ],
  },
  {
    id: "m4",
    title: "Has anything changed recently?",
    subtitle: "Select all that apply.",
    type: "multi",
    options: [
      { value: "moved", label: "Moved" },
      { value: "lost_coverage", label: "Lost coverage" },
      { value: "medicaid_changed", label: "Medicaid status changed" },
      { value: "newly_eligible", label: "Recently became eligible" },
      { value: "doctors_rx_changed", label: "Doctors or prescriptions changed" },
      { value: "none", label: "No major changes", exclusive: true },
    ],
  },
  {
    id: "m5",
    title: "When did you last review your Medicare coverage?",
    type: "single",
    options: [
      { value: "within_year", label: "Within the last year" },
      { value: "1_2_years", label: "1–2 years ago" },
      { value: "over_2_years", label: "More than 2 years ago" },
      { value: "never", label: "I've never reviewed it" },
      { value: "not_enrolled", label: "I'm not enrolled yet" },
      { value: "unsure", label: "Not sure" },
    ],
  },
];
